import { Component, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { MenuService } from 'src/app/menu/app.menu.service';
import { MenuElementInterface, computeTranslation } from 'src/app/model/menu';
import * as DeviceActions from 'src/app/store/device/device.actions';
import * as InvitationsActions from 'src/app/store/invitations/invitations.actions';
import { AppState } from 'src/app/store/app.reducer';
import * as UserActions from 'src/app/store/user/user.actions';
import * as SiteActions from 'src/app/store/site/site.actions';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectCurrentDevice } from 'src/app/store/device/device.selector';
import { Device } from 'src/app/model/device';
import { DEFAULT_LANG, LANGUAGES } from 'src/app/conf/languages';
import { Lang } from 'src/app/model/lang';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import { environment } from 'src/environments/environment';
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InvitationsDialogComponent } from 'src/app/modules/shared/components/invitations-dialog/invitations-dialog.component';
import { selectInvitationsList } from 'src/app/store/invitations/invitations.selector';
import { Invitations } from 'src/app/model/invitations';
import { RELEASE_NOTES_VIEW, RELEASE_PRIVACY_NOTES_VIEW } from 'src/app/model/user';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { INVITATIONS_PAGE_DEFAULT_SIZE } from 'src/app/conf/invitations';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	providers: [ConfirmationService, DialogService],
})

export class HomeComponent implements OnInit, OnDestroy {
	tabItems: MenuElementInterface[] = [
		{ stringId: 'CHANGE_PASSWORD', label: '', routerLink: 'change-password', id: 'tab-user-changepassword' },
		{ stringId: 'CHANGE_USERNAME', label: '', routerLink: 'change-username', id: 'tab-user-changeusername' }
	];
	sidebarOpen$: Observable<boolean>;
	notificationsbarOpen$: Observable<boolean>;
	menuClick!: boolean;
	overlayMenuActive!: boolean;
	rotateMenuButton!: boolean;

	topbarMenuActive!: boolean;

	staticMenuDesktopInactive!: boolean;

	staticMenuMobileActive!: boolean;
	rightPanelActive!: boolean;

	langSub: Subscription;
	rightPanelClick!: boolean;
	topbarItemClick!: boolean;

	activeTopbarItem: any;
	searchClick = false;
	menuHoverActive = false;

	search = false;

	screenWidth: number;

	lockMenuNotifications: boolean;

	documentClickListener: () => void;
	configActive: boolean;
	configClick: boolean;

	device: Device;
	device$: Observable<Device | undefined>;
	deviceSub: Subscription | undefined;

	invitationsList$: Observable<Invitations[] | undefined>;
	invitationsListSub: Subscription | undefined;

	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;

	private invitationsDialogRef?: DynamicDialogRef;

	constructor(
		public renderer: Renderer2,
		private menuService: MenuService,
		private store: Store<AppState>,
		private translate: TranslateService,
		public dialogService: DialogService,
		public app: AppComponent
	) {
		this.translate.onLangChange.subscribe(
			() => (this.tabItems = computeTranslation(this.translate, this.tabItems))
		);
		this.initSelectors();
	}

	setLockMenuNotifications() {
		this.lockMenuNotifications = true;
	}

	// eslint-disable-next-line @angular-eslint/use-lifecycle-interface
	ngAfterViewInit() {
		// hides the horizontal submenus or top menu if outside is clicked
		this.documentClickListener = this.renderer.listen('body', 'click', () => {
			if (!this.lockMenuNotifications) {
				if (!this.topbarItemClick) {
					this.activeTopbarItem = null;
					this.topbarMenuActive = false;
				}

				if (!this.menuClick && this.isHorizontal()) {
					this.menuService.reset();
				}

				if (this.configActive && !this.configClick) {
					this.configActive = false;
				}

				if (!this.rightPanelClick) {
					this.rightPanelActive = false;
				}

				if (!this.menuClick) {
					if (this.overlayMenuActive) {
						this.overlayMenuActive = false;
					}
					if (this.staticMenuMobileActive) {
						this.staticMenuMobileActive = false;
					}

					this.menuHoverActive = false;
					this.unblockBodyScroll();
				}

				if (!this.searchClick) {
					this.search = false;
				}

				this.searchClick = false;
				this.configClick = false;
				this.topbarItemClick = false;
				this.menuClick = false;
				this.rightPanelClick = false;
			} else {
				this.lockMenuNotifications = false;
			}
		});
	}

	initSelectors(): void {
		this.device$ = this.store.select(selectCurrentDevice);
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.invitationsList$ = this.store.select(selectInvitationsList);
	}

	ngOnInit(): void {
		let test = false;
		if (environment.apiUrl !== 'https://app.cameconnect.net/api') {
			test = true;
		}
		this.onResize();
		this.tabItems = computeTranslation(this.translate, this.tabItems);

		this.subscribeAll();

		this.langSub = this.store.select('user', 'currentLang').subscribe(lang => {
			const invitationsPaging : PaginationParams = { page: 1, size: INVITATIONS_PAGE_DEFAULT_SIZE };
			this.store.dispatch(InvitationsActions.getInvitationsPaginatedList({ paging: invitationsPaging, pending: true, created: false, invited: true }));

			this.store.dispatch(DeviceActions.getGateStates({ language: lang.code }));
			this.store.dispatch(DeviceActions.getGateErrors({ language: lang.code }));
			this.store.dispatch(DeviceActions.getErrorCodes());
			this.store.dispatch(DeviceActions.getDeviceModels({ language: lang.code, pagination: { page: 1, size: 0 } }));
			if (this.device !== undefined && this.device !== null) {
				this.store.dispatch(DeviceActions.getDeviceModel({ modelId: this.device.ModelId, language: lang.code }));
				this.store.dispatch(DeviceActions.getCommands({ device: this.device }));
			}
			this.store.dispatch(UserActions.getNotificationMaintenance());
			this.store.dispatch(UserActions.getReleaseNoteList({ size: RELEASE_NOTES_VIEW }));
			this.store.dispatch(UserActions.getPrivacyNoteList({ size: RELEASE_PRIVACY_NOTES_VIEW }));
		});
		this.store.dispatch(DeviceActions.getAutomationsFirmwares({ test }));
		this.store.dispatch(SiteActions.getSites({}));
		this.store.dispatch(DeviceVctActions.getSitesVctList());
		this.store.dispatch(SiteActions.getSitesOnlineDevices({}));
		this.store.dispatch(UserActions.unmuteWebsocket());
	}

	subscribeAll(): void {
		this.deviceSub = this.device$?.subscribe(
			(device) => {
				if (device !== undefined && device !== null) {
					this.device = device;
				}
			}
		);
		this.invitationsListSub = this.invitationsList$?.subscribe(
			(invitationsList) => {
				if (invitationsList !== undefined && invitationsList.length > 0) {
					this.showDialogInvitations();
				}
			}
		);
	}

	ngOnDestroy(): void {
		this.langSub?.unsubscribe();
		this.deviceSub?.unsubscribe();
		this.invitationsListSub?.unsubscribe();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onMenuClick($event: MouseEvent) {
		this.menuClick = true;
	}

	isTablet() {
		const width = window.innerWidth;
		return width <= 1024 && width > 640;
	}

	isDesktop() {
		return window.innerWidth > 992;
	}

	isMobile() {
		return window.innerWidth <= 640;
	}

	isOverlay() {
		return this.app.menuMode === 'overlay';
	}

	isStatic() {
		return this.app.menuMode === 'static';
	}

	isHorizontal() {
		return this.app.menuMode === 'horizontal';
	}

	onRightPanelClick() {
		this.rightPanelClick = true;
	}

	onTopbarItemClick(event: MouseEvent, item: any) {
		this.topbarItemClick = true;

		if (this.activeTopbarItem === item) {
			this.activeTopbarItem = null;
		} else {
			this.activeTopbarItem = item;
		}

		if (item.className === 'search-item topbar-item') {
			this.search = !this.search;
			this.searchClick = !this.searchClick;
		}

		event.preventDefault();
	}

	onTopbarSubItemClick(event: MouseEvent) {
		event.preventDefault();
	}

	onMenuButtonClick(event: MouseEvent) {
		this.rotateMenuButton = !this.rotateMenuButton;
		this.topbarMenuActive = false;
		this.menuClick = true;

		if (this.app.menuMode === 'overlay' && !this.isMobile()) {
			this.overlayMenuActive = !this.overlayMenuActive;
		}

		if (this.isDesktop()) {
			this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
		} else {
			this.staticMenuMobileActive = !this.staticMenuMobileActive;
			if (this.staticMenuMobileActive) {
				this.blockBodyScroll();
			} else {
				this.unblockBodyScroll();
			}
		}

		event.preventDefault();
	}


	blockBodyScroll(): void {
		if (document.body.classList) {
			document.body.classList.add('blocked-scroll');
		} else {
			document.body.className += ' blocked-scroll';
		}
	}

	unblockBodyScroll(): void {
		if (document.body.classList) {
			document.body.classList.remove('blocked-scroll');
		} else {
			document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
				'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	}


	showDialogInvitations(): void {
		if (this.invitationsDialogRef) { // se dialog è già aperto, non lo riapriamo
			return;
		}

		const ref = this.dialogService.open(InvitationsDialogComponent, {
			header: this.translate.instant('INVITATIONS_LIST'),
			width: '72vw',
			breakpoints: { '1400px': '98vw' },
			contentStyle: { overflow: 'auto' },
		});

		this.invitationsDialogRef = ref;
		ref.onClose.subscribe(() => {
			if (this.invitationsDialogRef === ref) {
					this.invitationsDialogRef = undefined;
			}
		});
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}
